import React, { useContext, useEffect, useState } from 'react'
import { v4 as uuid } from 'uuid'
import { EditWrapper } from '../../components'
import { DraftContext } from '../../components/ContextProvider'
import Subnav from './Subnav'
import TableRow from './TableRow'
import TableColumn from './TableColumn'
import { activeInput } from '../../lib/utility'
import useCompetitiveStore from '../../store/useCompetitiveStore'
import {
  // addItem,
  // deleteCard,
  // textEdit,
  arrayEdit,
  // initCompetitive,
} from '../../components/CompetitiveUtils'

function Product() {
  const { draft, draftId, initCompetitive } = useContext(DraftContext)
  const [module] = useState(draft.draft_id && draft ? draft : {})
  const [records, setRecords] = useState([])
  const [boardStyle, setBoardStyle] = useState('row')
  const { competitive, setField, price_symbol } = useCompetitiveStore(
    (state) => ({
      competitive: state.competitive,
      setField: state.setField,
      price_symbol: state.price_symbol,
    })
  )

  const boards = [
    {
      id: 1,
      title: '橫列比對',
      image: '/images/boards/board-row.svg',
      key: 'row',
    },
    {
      id: 2,
      title: '直欄比對',
      image: '/images/boards/board-column.svg',
      key: 'column',
    },
  ]

  const switchBoard = (board) => {
    setBoardStyle(board)
  }

  useEffect(() => {
    if (module.module2) {
      setRecords(
        module.module2.product.history && module.module2.product.history
      )
    }
  }, [module])

  useEffect(() => {
    activeInput()
  }, [])

  useEffect(() => {
    initCompetitive(setField)
  }, [])

  const reorder = (cardlist, startIndex, endIndex) => {
    const result = Array.from(cardlist)
    const [removed] = result.splice(startIndex, 1)
    result.splice(endIndex, 0, removed)

    return result
  }

  const onDragEnd = (result) => {
    const { source, destination } = result

    if (!destination) {
      return
    }

    setField(
      'competitive',
      reorder(competitive, source.index, result.destination.index)
    )
  }

  const addItem = async (labelID, brand_name) => {
    const index = competitive.findIndex((item) => item.id === labelID)
    const fake = JSON.parse(JSON.stringify(competitive))
    fake.splice(index + 1, 0, {
      isLoading: true,
    })
    setField('competitive', fake)

    const newData = JSON.parse(JSON.stringify(competitive))
    const response = await fetch(
      `${window.location.protocol}/api/draft/${draftId}/data/competitive_product_analysis/competitive_partial_generation/partial`,
      {
        method: 'post',
        body: JSON.stringify({
          q: brand_name,
        }),
        headers: {
          'content-type': 'application/json',
        },
      }
    )
    const json = await response.json()
    console.log(json)

    if (json) {
      newData.splice(index + 1, 0, {
        ...json.competitive,
        id: uuid(),
      })
      setField('competitive', newData)
    }
  }

  const regenerateItem = async (labelID, brand_name) => {
    const { bg } = competitive.find((item) => item.id === labelID)
    const index = competitive.findIndex((item) => item.id === labelID)
    const fake = JSON.parse(JSON.stringify(competitive))
    console.log(fake)
    fake.splice(index, 1, {
      isLoading: true,
    })
    setField('competitive', fake)
    console.log(index)
    console.log(brand_name)

    const newData = JSON.parse(JSON.stringify(competitive))
    const response = await fetch(
      `${window.location.protocol}/api/draft/${draftId}/data/competitive_product_analysis/competitive_partial_generation/partial`,
      {
        method: 'post',
        body: JSON.stringify({
          q: brand_name,
        }),
        headers: {
          'content-type': 'application/json',
        },
      }
    )

    const json = await response.json()
    console.log(json)
    // return {
    //   pestel: json.pestel,
    //   pestel_sub: json.pestel_info[0].pestel_sub,
    //   content: json.pestel_info[0].content,
    // }

    if (json) {
      newData.splice(index, 1, {
        ...json.competitive,
        bg,
      })
      setField('competitive', newData)
    }
  }
  console.log(competitive)

  const deleteCard = (labelID) => {
    let newData = JSON.parse(JSON.stringify(competitive))
    newData = newData.filter((item) => item.id !== labelID)
    setField('competitive', newData)
  }

  const textEdit = (id, value, label) => {
    let newData = JSON.parse(JSON.stringify(competitive))
    newData = newData.map((item) =>
      item.id === id ? { ...item, [label]: value } : item
    )
    setField('competitive', newData)
  }

  return (
    module.module2 && (
      <EditWrapper
        setting={{
          toolbarTitle: '生成競品分析',
          toolbarTitleDesc:
            '生成競品分析有兩個關鍵要素：<strong>「市場」</strong>和<strong>「產業/服務」</strong>。',
          showInput: module.show_input,
          moduleTitle: module.title,
          moduleKeyword: module.module2.keyword,
          records,
          boards,
          boardStyle,
          switchBoard,
        }}
      >
        <>
          <Subnav setting={{ currentID: 1 }} />
          <div className="tab-panel">
            {boardStyle === 'row' && (
              <TableRow
                setting={{
                  module: competitive,
                  onDragEnd,
                  addItem: (labelID, value) => addItem(labelID, value),
                  deleteCard: (labelID) =>
                    deleteCard(labelID, competitive, setField),
                  textEdit: (id, value, label) =>
                    textEdit(id, value, label, competitive, setField),
                  arrayEdit: (label, value, type, i) =>
                    arrayEdit(label, value, type, i, competitive, setField),
                  setIsLoading: () => {},
                  priceType: price_symbol,
                  setPriceType: (value) => {
                    setField('price_symbol', value)
                  },
                  regenerateItem,
                }}
              />
            )}

            {boardStyle === 'column' && (
              <TableColumn
                setting={{
                  module: competitive,
                  onDragEnd,
                  addItem: (labelID) => addItem(labelID, competitive, setField),
                  deleteCard: (labelID) =>
                    deleteCard(labelID, competitive, setField),
                  textEdit: (id, value, label) =>
                    textEdit(id, value, label, competitive, setField),
                  arrayEdit: (label, value, type, i) =>
                    arrayEdit(label, value, type, i, competitive, setField),
                  setIsLoading: () => {},
                  priceType: price_symbol,
                  regenerateItem,
                }}
              />
            )}
          </div>
        </>
      </EditWrapper>
    )
  )
}

export default Product
